<template>
	<v-app id="app">
		<AppAlert />
		<AppBar v-if="this.$route.path != '/exemplos' && this.$route.path != '/mercadopago'" />
		<AppContent v-if="!loading" />
		<AppLoading v-if="loading" />
		<AppFooter />
	</v-app>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AppBar from './components/template/AppBar'
import AppFooter from './components/template/AppFooter'
import AppContent from './components/template/AppContent'
import AppLoading from './components/widgets/AppLoading'
import AppAlert from './components/widgets/AppAlert'

export default {
	components: {
		AppBar,
		AppContent,
		AppLoading,
		AppAlert,
		AppFooter,
	},
	data: function () {
		return {
			loading: true,
			empresa: {},
			catalogo: {},
			expirado: false,
			horaFuncionamento: false,
			aberto: false,
			itens: {},
			marcas: {},
			rotasPublicas: ['Signin', 'Signup'],
			fpagamento: [],
		}
	},
	computed: {
		...mapGetters({
			cartProducts: 'cartProducts',
		}),
	},
	methods: {
		loadCores() {
			var convert = require('color-convert')
			var hslPrimary = convert.hex.hsl(this.empresa.primaryColor)
			var hslBack = convert.hex.hsl(this.empresa.backgroundColor)[2]
			var hslPromocao = convert.hex.hsl(this.empresa.promocaoColor)[2]

			var texto = hslBack > 70 ? '#000' : '#FFF'
			var textoBotoes = hslPrimary[2] > 70 ? '#000' : '#FFF'
			var textoPromocao = hslPromocao > 70 ? '#000' : '#FFF'
			var textoPrecoAntigo = hslBack > 70 ? '#808080' : '#d9d9d9'
			var primaryHover = convert.hsl.hex(hslPrimary[0], hslPrimary[1], hslPrimary[2] > 10 ? hslPrimary[2] - 10 : hslPrimary[2] + 10)

			this.$vuetify.theme.themes.light.primary = this.empresa.primaryColor
			this.$vuetify.theme.themes.light.primaryHover = primaryHover
			this.$vuetify.theme.themes.light.background = this.empresa.backgroundColor
			this.$vuetify.theme.themes.light.promocao = this.empresa.promocaoColor
			this.$vuetify.theme.themes.light.texto = texto
			this.$vuetify.theme.themes.light.textoBotoes = textoBotoes
			this.$vuetify.theme.themes.light.textoPromocao = textoPromocao 
			this.$vuetify.theme.themes.light.textoPrecoAntigo = textoPrecoAntigo
		},
		async loadEmpresa() {
			try {
				this.loading = true
				const _identificador = await this.axios.get(`/identificador/${this.$route.params.catalogo}`)
				this.empresa = _identificador.data.empresa
				this.catalogo = _identificador.data.catalogo
				this.expirado = _identificador.data.expirado
				this.fpagamento = _identificador.data.fpagamentos
				this.horaFuncionamento = _identificador.data.horaFuncionamento
				this.aberto = _identificador.data.aberto

				this.loadCores()

				this.addEmpresa(this.empresa)
				this.addCatalogo(this.catalogo)
				this.addFpagamento(this.fpagamento)
				this.addStatusCatalogo({
					expirado: this.expirado,
					horaFuncionamento: this.horaFuncionamento,
					aberto: this.aberto,
				})
			} catch (error) {
				//reg erro
			} finally {
				this.loading = false
			}
		},
		...mapActions(['addEmpresa', 'addCatalogo', 'addStatusCatalogo', 'addFpagamento']),
	},
	async mounted() {
		await this.loadEmpresa()
		//await this.carregarCarrinhoLocal()
		//await this.validarCarrinhoLocal()
	},
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');

.v-application {
	font-family: 'Inter', Roboto;
}

#app {
	background: var(--v-background-base);
}

html, body { overflow-x: hidden; }

.v-btn > .v-btn__content .v-icon {
	color: var(--v-textoBotoes-base);
}
</style>